import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PermissionState {
  [key: string]: {
    allowed: boolean;
    timestamp: number;
  };
}

const initialState: PermissionState = {};

const permissionSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermission: (
      state,
      action: PayloadAction<{
        module?: string;
        action?: string;
        allowed?: boolean;
      }>
    ) => {
      const key = `${action.payload.module}-${action.payload.action}`;
      state[key] = {
        allowed: action.payload.allowed || false,
        timestamp: Date.now(),
      };
    },
  },
});

export const { setPermission } = permissionSlice.actions;
export { permissionSlice };
